import { createContext, Dispatch, SetStateAction } from 'react';

interface SignUpContextProps {
    useVerified: [boolean, Dispatch<SetStateAction<boolean>>];
    usePhoneNo: [string, Dispatch<SetStateAction<string>>]
    useMarketing: [boolean, Dispatch<SetStateAction<boolean>>];
    useLocation: [boolean, Dispatch<SetStateAction<boolean>>];
    useInputPhoneNo: [string, Dispatch<SetStateAction<string>>];
    useInputSmsAuthCode: [string, Dispatch<SetStateAction<string>>];
    useSelectedTermCategories: [string[], Dispatch<SetStateAction<string[]>>];
    nickname?: string;
    kakaoId?: number;
    appleId?: string;
}

const SignUpContext = createContext<SignUpContextProps>({} as SignUpContextProps);

export default SignUpContext;
